<b-modal v-model="modal_special_requirement_ECM2" size="md" :header-bg-variant="headerColor"
  header-text-variant="light" no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">
      <template v-if="phase === 'start'">
        {{ $t('individual.common_title_execution') }}
      </template>
      <template v-if="phase === 'trans'">
        {{ $t('message.common_title_confirmation') }}
      </template>
      <template v-if="phase === 'success'">
        {{ $t('message.common_title_success') }}
      </template>
      <template v-if="phase === 'failed' || phase === 'transFailed'">
        {{ $t('message.common_title_error') }}
      </template>
    </div>
  </template>

  <template v-slot:default>
    <ShowLessBOverlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <!-- 実行中 -->
        <template v-if="phase === 'start'"></template>
        <!-- モード遷移, 成功, 失敗表示  -->
        <template v-if="phase === 'trans' || phase === 'success' || phase === 'transFailed'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="text-left align-middle">
                <div v-html="$t(displayInfo)" class="box-margin-right work-support-message"></div>
              </div>
            </div>
          </div>
        </template>
        <!-- 共通エラー -->
        <template v-if="phase === 'failed'">
          <div class="w-100">
            <div class="box-margin-right work-support-message">{{ $t(`individual.error_communication_error`) }}</div>
          </div>
        </template>
      </div>
    </ShowLessBOverlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center ">
      <!-- モード遷移 -->
      <template v-if="phase === 'trans'">
        <b-button size="sm" variant="outline-primary" :disabled="isLoading" @click="closeWizard" class="mx-2">
          {{ $t('message.common_button_cancel') }}
        </b-button>
        <b-button size="sm" variant="primary" :disabled="isLoading" @click="sessionProcessEvent" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
      <!-- 成功、失敗表示 -->
      <template v-if="phase === 'success' || phase === 'failed' || phase === 'transFailed'">
        <b-button size="sm" variant="primary" :disabled="isLoading" @click="closeWizard" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
    </div>
  </template>
</b-modal>